import React from "react";
import PropTypes from "prop-types";
import {
  Drawer,
  IconButton,
  Toolbar,
  Typography,
  Box,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import drawerStyle from './style.module.scss'


import styled, { createGlobalStyle } from 'styled-components';
const HideTrengoChat = createGlobalStyle`
#trengo-web-widget{
  display: none !important;
}
`;

function SideDrawer(props) {
  const { onClose, open, title, children, style, variant='temporary' } = props;
  return (
    <Drawer anchor="right" open={open} variant={variant} onClose={onClose} classes={{paper: drawerStyle.contactDrawer}} PaperProps={{style}}>
      <HideTrengoChat />
      <Toolbar className={drawerStyle.toolbar}>
        <Box
          display="flex"
          justifyContent="space-between"
          width="100%"
          alignItems="center"
        >
          <Typography variant="h6" className={drawerStyle.title}>
            {title}
          </Typography>
          <IconButton
            onClick={onClose}
            color="primary"
            aria-label="Close Sidedrawer"
            className={drawerStyle.muiIconButtonColorPrimary}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </Toolbar>

      <div>
        {children}
      </div>
    </Drawer>
  );
}

SideDrawer.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};

export default SideDrawer;
